import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M4.64 2.64A4.75 4.75 0 0 1 12.75 6c0 2.22.48 3.6.9 4.4a3.87 3.87 0 0 0 .63.85l.15.13-.02-.01-.1-.1.08.09.02.01h.01v.01a.75.75 0 0 1-.42 1.37H2a.75.75 0 0 1-.43-1.37l.04-.02.16-.16c.14-.15.35-.41.57-.8.43-.8.91-2.18.91-4.4 0-1.26.5-2.47 1.4-3.36Zm1.52 10.69a.75.75 0 0 1 1.01.33c.1.2.23.35.38.45.15.1.3.14.45.14a.8.8 0 0 0 .45-.14c.15-.1.28-.25.38-.45a.75.75 0 1 1 1.34.68c-.2.4-.5.76-.89 1.02a2.3 2.3 0 0 1-2.56 0c-.38-.26-.68-.61-.9-1.02a.75.75 0 0 1 .34-1.01Zm5.36-4.55a8.45 8.45 0 0 0 .9 2.47H3.58l.08-.14C4.23 10.07 4.75 8.44 4.75 6a3.25 3.25 0 0 1 6.5 0c0 1.08.1 2 .27 2.78Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }